// Sistema traduzioni centralizzato. IT predefinito; EN predisposto.
export const translations = {
  it: {
    nav: { home: "Home", properties: "Strutture", destinations: "Destinazioni", about: "Chi siamo", book: "Prenota", contact: "Contatti", bookNow: "Prenota ora" },
    hero: {
      title: "Luoghi da vivere, non soltanto da visitare.",
      subtitle: "Scopri una collezione di ville, appartamenti e dimore selezionate, gestite personalmente per offrirti un soggiorno autentico e senza pensieri.",
      cta1: "Scopri le strutture",
      cta2: "Prenota il tuo soggiorno",
      scroll: "Scorri",
    },
    search: { title: "Trova il tuo soggiorno", destination: "Destinazione o struttura", checkin: "Check-in", checkout: "Check-out", guests: "Ospiti", submit: "Cerca disponibilità", all: "Tutte le destinazioni" },
  },
  en: {
    nav: { home: "Home", properties: "Stays", destinations: "Destinations", about: "About", book: "Book", contact: "Contact", bookNow: "Book now" },
    hero: {
      title: "Places to live, not merely to visit.",
      subtitle: "Discover a curated collection of villas, apartments and homes, personally managed for an authentic and effortless stay.",
      cta1: "Explore the stays",
      cta2: "Book your stay",
      scroll: "Scroll",
    },
    search: { title: "Find your stay", destination: "Destination or property", checkin: "Check-in", checkout: "Check-out", guests: "Guests", submit: "Check availability", all: "All destinations" },
  },
};
